var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUranus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 338.03 486.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eb53c0;}.cls-2,.cls-3{fill:#9ce8e6;}.cls-3{opacity:0.3;}.cls-4{fill:#10fcf5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 169.1,
    cy: 235.99,
    r: 168.93,
    transform: "translate(-117.34 188.69) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.56,120.44c0,5.32-4.82,9.63-10.77,9.63S143,125.76,143,120.44s4.82-9.64,10.76-9.64S164.56,115.12,164.56,120.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58,182.79c0,5.94-3.3,10.77-7.36,10.77s-7.37-4.83-7.37-10.77S46.57,172,50.64,172,58,176.84,58,182.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.23,240.6c0,6-5.59,10.77-12.47,10.77s-12.47-4.82-12.47-10.77,5.58-10.77,12.47-10.77S153.23,234.65,153.23,240.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M266.59,128.94c0,4.38-3.3,7.94-7.37,7.94s-7.37-3.56-7.37-7.94,3.3-7.94,7.37-7.94S266.59,124.56,266.59,128.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.44,194.69c0,4.38-4.31,7.93-9.63,7.93s-9.64-3.55-9.64-7.93,4.32-7.94,9.64-7.94S214.44,190.31,214.44,194.69Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 306.27,
    cy: 260.44,
    rx: 11.34,
    ry: 6.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.6,304.65c0,3.76-1.77,6.8-4,6.8s-4-3-4-6.8,1.77-6.8,4-6.8S54.6,300.89,54.6,304.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185,388.54c0,2.5-3.55,4.53-7.94,4.53s-7.93-2-7.93-4.53S172.65,384,177,384,185,386,185,388.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.45,315.42c0,3.44-3.3,6.23-7.37,6.23s-7.37-2.79-7.37-6.23,3.3-6.24,7.37-6.24S248.45,312,248.45,315.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.53,176.55a6.26,6.26,0,1,1-6.23-5.67A6,6,0,0,1,308.53,176.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.28,117.6a4.54,4.54,0,1,1-4.53-4.53A4.53,4.53,0,0,1,94.28,117.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.15,335.26c0,3.75-3.8,6.8-8.5,6.8s-8.5-3.05-8.5-6.8,3.81-6.8,8.5-6.8S127.15,331.5,127.15,335.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M168.93,404.54a169,169,0,0,0,42.7-332.42c-1,6.29-.07,13.81,3.58,22.53,13.56,32.45,41.91,58.6,56.18,90.64,29.93,67.18,22.15,146-59,167.3-32.9,8.65-73.32,3.27-100.27-17-31-23.3-25.83-59.53-20-93.6,5.83-33.88,33.16-87.61,15.41-121.67-4.71-9-22.68-28.72-43-17.59A168.94,168.94,0,0,0,168.93,404.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M211,62.06S240.52,2,264.32,12.18s9.07,117.89-43.08,230.12S127.15,462.22,93.15,469s-2.27-74.81-2.27-74.81h-6.8S55.74,483.7,85.21,486s107.16-145.87,145.1-238C277.92,132.34,298.36,12.09,271.12,2,231.45-12.76,202,59.79,202,59.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M187.24,106.27l-7.94-3.4c-3.39-5.72-18.45-8.67-25.14-9.06-14-.83-34,8.76-46.56,14.73-22.69,10.81-58.85,33.79-70.31,56.93-8.9,18-8.8,49-6.75,68,2.68,24.91,7.17,49.1,36.51,55.58,28.71,6.34,50.12-16.8,56.73-43.29,5.82-23.36,3.86-51.39,28.34-63.27,16.13-7.83,35.89-13.49,43.9-32C201.83,137,204.71,112.51,187.24,106.27Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUranus);
export default __webpack_public_path__ + "static/media/uranus.358fa6f771357bfafcbffb518329f7cf.svg";
export { ForwardRef as ReactComponent };